import { User } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const UserIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <User width={size} height={size} color={color} {...rest} />;

UserIcon.displayName = 'UserIcon';

export default UserIcon;
